export const endpointsList = [
  {
    id: 0,
    type: "GET",
    name: "GetIpData",
    path: "/api-docs/endpoints/GetIpData",
  },
  {
    id: 1,
    type: "GET",
    name: "GetBalance",
    path: "/api-docs/endpoints/GetBalance",
  },
  {
    id: 2,
    type: "GET",
    name: "GetRequestsLeft",
    path: "/api-docs/endpoints/GetRequestsLeft",
  },
  {
    id: 3,
    type: "GET",
    name: "GetSubscriptions",
    path: "/api-docs/endpoints/GetSubscriptions",
  },
];
